import React from 'react';

const UserGrowth = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white shadow rounded-lg p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">User Growth</h3>
        <p className="text-sm text-gray-500">No data available</p>
      </div>
    );
  }

  // Calculate cumulative totals
  let cumulative = 0;
  const cumulativeData = data.map(item => {
    cumulative += item.count;
    return { ...item, cumulative };
  });

  const maxValue = Math.max(...cumulativeData.map(d => d.cumulative));
  const chartHeight = 200;

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">User Growth</h3>

      {/* Line Chart using SVG */}
      <div className="mt-4">
        <svg width="100%" height={chartHeight} className="overflow-visible">
          {/* Grid lines */}
          {[0, 0.25, 0.5, 0.75, 1].map((percent, i) => (
            <g key={i}>
              <line
                x1="0"
                y1={chartHeight - 40 - (chartHeight - 60) * percent}
                x2="100%"
                y2={chartHeight - 40 - (chartHeight - 60) * percent}
                stroke="#e5e7eb"
                strokeWidth="1"
              />
              <text
                x="0"
                y={chartHeight - 40 - (chartHeight - 60) * percent - 4}
                fill="#6b7280"
                fontSize="12"
              >
                {Math.round(maxValue * percent)}
              </text>
            </g>
          ))}

          {/* Line path */}
          <path
            d={cumulativeData.map((item, index) => {
              const x = (index / (cumulativeData.length - 1)) * 100;
              const y = chartHeight - 40 - ((item.cumulative / maxValue) * (chartHeight - 60));
              return `${index === 0 ? 'M' : 'L'} ${x}% ${y}`;
            }).join(' ')}
            fill="none"
            stroke="#3b82f6"
            strokeWidth="3"
            strokeLinecap="round"
          />

          {/* Data points */}
          {cumulativeData.map((item, index) => {
            const x = (index / (cumulativeData.length - 1)) * 100;
            const y = chartHeight - 40 - ((item.cumulative / maxValue) * (chartHeight - 60));

            return (
              <g key={index}>
                <circle
                  cx={`${x}%`}
                  cy={y}
                  r="4"
                  fill="#3b82f6"
                  className="cursor-pointer hover:r-6 transition-all"
                >
                  <title>{`${new Date(item.date).toLocaleDateString()}: ${item.cumulative} total users`}</title>
                </circle>
              </g>
            );
          })}
        </svg>

        {/* X-axis labels */}
        <div className="flex justify-between mt-2 px-2">
          {cumulativeData.filter((_, i) => i % Math.ceil(cumulativeData.length / 6) === 0).map((item, index) => (
            <span key={index} className="text-xs text-gray-600">
              {new Date(item.date).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric'
              })}
            </span>
          ))}
        </div>
      </div>

      {/* Summary Stats */}
      <div className="mt-6 grid grid-cols-3 gap-4">
        <div>
          <dt className="text-sm font-medium text-gray-500">Total Users</dt>
          <dd className="mt-1 text-2xl font-semibold text-gray-900">
            {cumulative.toLocaleString()}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-500">New This Period</dt>
          <dd className="mt-1 text-2xl font-semibold text-gray-900">
            {data.reduce((sum, item) => sum + item.count, 0).toLocaleString()}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-500">Avg. Daily Growth</dt>
          <dd className="mt-1 text-2xl font-semibold text-gray-900">
            {(data.reduce((sum, item) => sum + item.count, 0) / data.length).toFixed(1)}
          </dd>
        </div>
      </div>
    </div>
  );
};

export default UserGrowth;
